<template>
  <div class="navigation-menu-router-dropdown">
    <slot name="elements"></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Main/Menu/NavigationMenuRouterDropdown.vue